<template>
  <a-spin :spinning="loading">
    <div class="answer-record">
      <div class="record-title">
        <a-icon type="profile" style="color: #1890ff" />
        答题记录
      </div>
      <div class="record-list">
        <div
          v-for="(record, index) in answerRecordList"
          :key="index"
          class="record-item"
        >
          <div class="record-time">{{ formatTime(record.time) }}</div>
          <div class="question-list">
            <div
              v-for="(question, qIndex) in record.questions"
              :key="qIndex"
              class="question-block"
            >
              <div class="question-title">
                {{ question.title }}
              </div>
              <div class="options-list">
                <div
                  v-for="(option, optionIndex) in question.options"
                  :key="optionIndex"
                  class="option-item"
                >
                  <span>{{ option.option }}</span>
                  <template v-if="option.type != 0">
                    <span> [ </span>
                    <span
                      v-if="option.type != 3"
                      :class="option.type == 1 ? 'answer' : 'selected'"
                    >
                      {{ option.type == 1 ? "正" : "答" }}
                    </span>
                    <template v-else>
                      <span class="answer"> 正 </span>
                      <span>,</span>
                      <span class="selected"> 答 </span>
                    </template>
                    <span> ] </span>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="record-empty" v-if="answerRecordList.length == 0">
        <a-empty description="暂无数据" />
      </div>
    </div>
  </a-spin>
</template>

<script>
import { queryMessageRecordApi } from "@/api/active";
import store from "@/store";
import moment from "moment";
export default {
  name: "CardMessageRecord",
  props: {
    customerId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      answerRecordList: [],
    };
  },
  methods: {
    // 格式化时间
    formatTime(time) {
      return moment(time).format("YYYY-MM-DD HH:mm:ss");
    },
    async getMessageRecord() {
      const corpId = store.getters.corpId || localStorage.getItem("corpId");
      if (!corpId) {
        this.$message.warning("corpId 参数缺失");

        return;
      }
      this.loading = true;
      const res = await queryMessageRecordApi({
        corpId,
        externalUserId: this.customerId,
      });
      console.log(res);
      this.loading = false;
      if (res.code == 200) {
        this.answerRecordList = res.result.map((answer) => {
          return {
            ...JSON.parse(answer.answer_sheet),
            time: answer.answer_time,
          };
        });
      } else {
        this.$message.error("查询留言记录失败");
      }
    },
  },
  mounted() {
    this.getMessageRecord();
  },
};
</script>

<style scoped lang="less">
.answer-record {
  background: #fff;
  padding: 0 8px;
  margin-top: -8px;
  .record-title {
    background: #e6f7ff;
    padding: 8px 12px;

    font-size: 14px;
    display: flex;
    align-items: center;

    .anticon {
      margin-right: 8px;
    }
  }

  .record-list {
    padding-top: 16px;
    padding-bottom: 16px;
    .record-item {
      margin-bottom: 16px;
      padding-bottom: 12px;
      background: #f2f2f2;
      &:last-child {
        margin-bottom: 0;
      }
      .record-time {
        padding: 8px 12px;
        color: #1890ff;
        font-size: 16px;
      }

      .question-list {
        .question-block {
          padding: 0 12px;
          margin-bottom: 12px;
          border-radius: 4px;

          &:last-child {
            margin-bottom: 0;
          }

          .question-title {
            margin-bottom: 8px;
            color: #333;
          }

          .options-list {
            display: flex;
            flex-wrap: wrap;
            margin: 0 -8px;

            .option-item {
              padding: 0 14px;
              margin-bottom: 4px;
              color: #333;
              white-space: nowrap;
              // 正确答案
              .answer {
                color: #2ac0a5;
              }
              // 选择的
              .selected {
                color: #1890ff;
              }
            }
          }
        }
      }
    }
  }
}
</style>
